<template id="upload_temp">
     <b-form @submit="onSubmit" id="upload_form" class="col-5 container">
       <div>
             <b-overlay :show="show_form" rounded="sm">
               <div class="form-group">
                 <label for="rfc">RFC</label>
                 <input type="text" class="form-control" id="rfc" v-model="rfc"
                        placeholder="Ingresa RFC" onkeyup="this.value = this.value.toUpperCase();">
                 <div v-if="seen_rfc_error" class="alert alert-primary" >
                   Rfc no puede estar vacío
                 </div>
                 <label for="password">Contraseña</label>
                 <input type="password" class="form-control" id="password" v-model="password" placeholder="Ingresa contraseña">
                 <div v-if="seen_pass_error" class="alert alert-primary" >
                   Contraseña no puede estar vacía
                 </div>
               </div>
               <div id="ficheros">
                 <b-form-group label-for="file_cer" label="Fichero Cer">
                     <b-form-file name="file_cer" id="file_cer" placeholder="No se ha seleccionado un archivo"
                                 accept=".cer" v-on:change="onFileChange($event, 'ficheroCer')"
                                  browse-text="Seleccionar" class="text-nowrap text-truncate">
                     </b-form-file>
                 </b-form-group>
                 <b-form-group label-for="file_key" label="Fichero Key">
                     <b-form-file name="file_key" id="file_key" placeholder="No se ha seleccionado un archivo"
                                  accept=".key" v-on:change="onFileChange($event, 'ficheroKey')"
                                  browse-text="Seleccionar" class="text-nowrap text-truncate">
                     </b-form-file>
                 </b-form-group>
               </div>
               <div id="Rango de fechas">
                 <b-form-group label-for="fecha-inicial" label="Fecha inicial">
                   <b-form-datepicker label-no-date-selected="Seleccione una fecha"
                                      id="fecha-inicial" v-model="fechaInicial" :min="min" :max="max" class="mb-2"></b-form-datepicker>
                 </b-form-group>
                 <b-form-group label-for="fecha-final" label="Fecha Final">
                   <b-form-datepicker label-no-date-selected="Seleccione una fecha"
                                      id="fecha-final" v-model="fechaFinal" :min="min" :max="max" class="mb-2"></b-form-datepicker>
                 </b-form-group>
                 <div v-if="seen_dates_error" class="alert alert-primary" >
                   Rango de fechas inválido
                 </div>
               </div>
               <div class="form-group" >
                 <b-form-group label="Tipo de archivos">
                   <b-form-checkbox-group v-model="selected" name="some-radios">
                     <b-form-checkbox v-model="checkedTypes" value="I">Ingresos</b-form-checkbox>
                     <b-form-checkbox v-model="checkedTypes" value="E">Egresos</b-form-checkbox>
                     <b-form-checkbox v-model="checkedTypes" value="T">Traslados</b-form-checkbox>
                     <b-form-checkbox v-model="checkedTypes" value="N">Nómina</b-form-checkbox>
                     <b-form-checkbox v-model="checkedTypes" value="P">Doc. Pago</b-form-checkbox>
                   </b-form-checkbox-group>
                 </b-form-group>
                 <div v-if="seen_tipos_error" class="alert alert-primary" >
                   Selecciona tipo(s) de archivo(s)
                 </div>
               </div>
               <div id="pdf">
               <b-form-group label="Incluir archivos">
                 <b-form-checkbox-group v-model="selectedPdf" name="some-radios">
                   <b-form-checkbox v-model="pdf" value="pdf">Pdf</b-form-checkbox>
                 </b-form-checkbox-group>
               </b-form-group>
               </div>

               <div class="centrado">
                 <b-button class="btn btn-primary"
                         type="submit" :disabled="show_form" ref="submit" variant="primary">Descargar</b-button>
               </div>
               <b-modal id="modal-error">
                 <template v-slot:modal-title>
                    Mensaje
                 </template>
                 <div class="d-block text-center">
                  <h3>{{mensaje_error_general}}</h3>
                 </div>
               </b-modal>
             </b-overlay>
       </div>
     </b-form>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Main',
  methods: {
    onFileChange (e, ficheroId) {
      console.log(ficheroId)
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (let i = files.length - 1; i >= 0; i--) {
        this.createFile(files[i], ficheroId)
      }
    },
    createFile (file, ficheroId) {
      let reader = new FileReader()
      let vm = this
      reader.onload = (e) => {
        if (ficheroId === 'ficheroCer') {
          vm.file_cer = e.target.result
        }
        if (ficheroId === 'ficheroKey') {
          vm.file_key = e.target.result
        }
      }
      reader.readAsDataURL(file)
    },
    upload (payload) {
      const path = 'https://dm.miskuentas.com/api/upload'
      // const path = 'https://api-vue-flask-sat.herokuapp.com/api/upload'
      axios.post(path, payload, {responseType: 'blob'}).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        console.log(res.status)
        link.href = url
        link.setAttribute('download', this.rfc + '.zip')
        document.body.appendChild(link)
        link.click()
        this.show_form = !this.show_form
      }).catch((error) => {
        this.show_form = !this.show_form
        if (error.response.status === 401) {
          this.mensaje_error_general = 'Credenciales inválidas'
        }
        if (error.response.status === 503) {
          this.mensaje_error_general = 'Seguimos procesando tu solicitud'
        }
        if (error.response.status === 406) {
          this.mensaje_error_general = 'Solicitud rechezada por el SAT'
        }
        this.$bvModal.show('modal-error')
        console.log(error)
      })
    },
    formatDate (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + (d.getDate())
      var year = d.getFullYear()
      if (month.length < 2) {
        month = '0' + month
      }
      if (day.length < 2) {
        day = '0' + day
      }
      return [year, month, day].join('/')
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.seen_general_error = false
      this.seen_dates_error = false
      const payload = {
        fiel_cer: this.file_cer,
        fiel_key: this.file_key,
        fecha_inicial: this.formatDate(this.fechaInicial),
        fecha_final: this.formatDate(this.fechaFinal),
        rfc: this.rfc,
        fiel_pass: this.password,
        tipos: this.checkedTypes,
        pdf: this.pdf
      }
      console.log(payload)
      this.seen_rfc_error = this.rfc === ''
      this.seen_pass_error = this.password === ''
      this.seen_tipos_error = this.checkedTypes.length === 0
      this.seen_dates_error = (new Date(this.fechaInicial) > new Date(this.fechaFinal))
      console.log(this.seen_dates_error)
      if (this.rfc !== '' && this.password !== '' && this.checkedTypes.length !== 0 && this.seen_dates_error === false) {
        this.show_form = true
        this.upload(payload)
      }
    }
  },
  data () {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 12)
    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth())
    let fechaInicial = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate() + 1)
    let password = ''
    let fechaFinal = today
    let rfc = ''
    return {
      fechaInicial,
      fechaFinal,
      rfc,
      password,
      checkedTypes: [],
      selectedPdf: [],
      pdf: [],
      show_form: false,
      seen_rfc_error: false,
      seen_pass_error: false,
      seen_dates_error: false,
      min: minDate,
      max: maxDate,
      seen_tipos_error: false,
      seen_general_error: false,
      mensaje_error_general: 'Ha ocurrido un error'
    }
  },
  created () {
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue